import { render, staticRenderFns } from "./OutdatedRegister.vue?vue&type=template&id=53047818&"
import script from "./OutdatedRegister.vue?vue&type=script&lang=js&"
export * from "./OutdatedRegister.vue?vue&type=script&lang=js&"
import style0 from "./OutdatedRegister.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports